import { NgModule } from "@angular/core";
import { S25DndSortableDirective } from "./s25.dnd.sortable.directive";
import { CommonModule } from "@angular/common";
import { S25DndSortableItemDirective } from "./s25.dnd.sortable.item.directive";
import { S25AutoScrollDirective } from "./s25.auto.scroll.directive";

import { S25IconComponent } from "../s25-icon/s25.icon.component";

@NgModule({
    imports: [CommonModule, S25IconComponent],
    exports: [S25DndSortableDirective, S25DndSortableItemDirective, S25AutoScrollDirective],
    providers: [],
    declarations: [S25DndSortableDirective, S25DndSortableItemDirective, S25AutoScrollDirective],
})
export class S25DndSortableModule {}
